import { listItem, shortenNumber } from '@/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface FilterButtonProps {
  item: listItem;
  setActiveButton: (item: string) => void;
  checkActive: (item: string) => 'primary' | 'default';
  badgeCount?: number;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  item,
  badgeCount,
  setActiveButton,
  checkActive,
}) => {
  const isActive = checkActive(item.value) === 'primary';
  const { t } = useTranslation();
  return (
    <button
      type='button'
      onClick={() => setActiveButton(item.value)}
      className={[
        'inline-flex items-center gap-1.5 h-8 px-3 rounded-lg text-[12px] font-medium cursor-pointer transition-colors whitespace-nowrap',
        isActive
          ? 'bg-[rgb(237,224,74)] text-[rgb(57,57,60)] hover:bg-[rgb(230,217,60)]'
          : 'bg-white border border-solid border-[rgb(232,230,227)] text-[rgb(115,123,140)] hover:text-[rgb(57,57,60)] hover:bg-[rgb(245,245,243)]',
      ].join(' ')}
    >
      {t(item.title)}
      {(badgeCount ?? 0) > 0 && (
        <span
          className='text-[10px] font-bold px-1.5 py-0.5 rounded-md leading-none'
          style={{
            backgroundColor: isActive ? 'rgba(0,0,0,0.1)' : 'rgb(245,245,243)',
            color: isActive ? 'rgb(57,57,60)' : 'rgb(115,123,140)',
          }}
        >
          {shortenNumber(badgeCount ?? 0)}
        </span>
      )}
    </button>
  );
};

export default FilterButton;
